import { render, staticRenderFns } from "./BlockedPhrasesCreatePopup.vue?vue&type=template&id=084fabe9"
import script from "./BlockedPhrasesCreatePopup.vue?vue&type=script&lang=js"
export * from "./BlockedPhrasesCreatePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports